import { cn } from '../../lib/cn.ts';

export interface ChatTypingProps {
  /** What a screen reader hears instead of the dots, e.g. "Wundo is typing". */
  label: string;
  className?: string;
}

/**
 * Wundo is working on a reply.
 *
 * A reply arrives whole rather than word by word, so this is the only sign
 * anything is happening — it stands where the message will appear.
 */
export function ChatTyping({ label, className }: ChatTypingProps) {
  return (
    <div
      data-slot='chat-typing'
      className={cn('flex items-center gap-1.5 px-1', className)}
    >
      <span className='sr-only'>{label}</span>
      {[0, 1, 2].map((dot) => (
        <span
          key={dot}
          aria-hidden='true'
          className={cn(
            'size-1.5 animate-bounce rounded-full bg-ink-faint',
            dot === 1 && 'delay-150',
            dot === 2 && 'delay-300',
          )}
        />
      ))}
    </div>
  );
}
